import { LucideIcon } from "lucide-react";
import { motion } from "framer-motion";
import { Button } from "../ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../ui/tooltip";

interface ResourceCardProps {
  title: string;
  description: string;
  icon: LucideIcon;
  link: string;
  index: number;
}

export const ResourceCard = ({ title, description, icon: Icon, link, index }: ResourceCardProps) => {
  const handleResourceClick = () => {
    window.open(link, '_blank');
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      viewport={{ once: true }}
      onClick={handleResourceClick}
      className="p-6 bg-white rounded-2xl shadow-sm hover:shadow-md transition-all duration-200 group cursor-pointer w-full flex flex-col h-full"
    >
      <div className="mb-4 text-spirit-600 flex justify-center">
        <Icon className="w-8 h-8 group-hover:scale-110 transition-transform duration-200" />
      </div>
      <h3 className="text-xl font-medium text-gray-900 mb-2">
        {title}
      </h3>
      <p className="text-gray-600 mb-4 flex-grow">{description}</p>
      <div className="mt-auto">
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant="secondary"
                className="bg-spirit-100 hover:bg-spirit-200 text-spirit-700 w-full"
                onClick={(e) => {
                  e.stopPropagation(); // Prevent the card click event from firing
                  handleResourceClick();
                }}
              >
                Get Started
                <span className="text-xs text-spirit-500 block">
                  Affiliate Link
                </span>
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              <p className="text-sm">This is an affiliate link. See our <a href="/legal/affiliate-disclosure" className="underline">disclosure</a> for details.</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    </motion.div>
  );
};